import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"flex-start","gap":"6px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  class: "titleDD",
  style: {"margin":"0"}
}, "Documentos soporte", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" * Los archivos adjuntos, no pueden tener el mismo nombre.")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" * En caso de adicionar más de un documento, da clic sobre el botón '+'")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" * Si necesitas eliminar uno de los documentos, da clic en 'x'")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" * Los tipos de archivos permitidos para cargar documentos son .pdf, .jpg y .png")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" * El tamaño máximo de todos los archivos cargados debe ser de 20 MB.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Adjuntar +")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Adjuntar +")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", {
  class: "titleDD",
  style: {"padding-top":"1em"}
}, " Aceptación y declaración juramentada de la veracidad de la información ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "declaracion-veracidad" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Actuando en nombre propio o en representación de una persona natural o jurídica debidamente facultado, declaro bajo la gravedad de juramento que la información y documentación suministradas son veraces, completas, actualizadas y verificables. "),
  /*#__PURE__*/_createElementVNode("p", null, " Así mismo, autorizo expresa e irrevocablemente a Aportes en Línea S.A. para consultar, validar y verificar la información proporcionada mediante fuentes de información públicas o privadas, bases de datos de referencia y listas de control, con el fin de adelantar los procesos de conocimiento, vinculación, debida diligencia y mantenimiento de la relación comercial o contractual, así como para dar cumplimiento a las obligaciones legales y regulatorias aplicables. "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" La presente autorización permanecerá vigente durante la relación contractual o comercial y por el término requerido para el cumplimiento de las disposiciones legales correspondientes. Al dar clic en la opción "),
    /*#__PURE__*/_createElementVNode("span", null, "He leído y acepto"),
    /*#__PURE__*/_createTextVNode(", manifiesto mi conformidad con lo aquí establecido y certifico la veracidad de la información registrada. ")
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "He leído y acepto", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" la declaración juramentada de la veracidad de la información ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "adicional-dialog-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cumplimiento de buenas prácticas y compromiso LAFT *")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", { style: {"list-style-type":"none"} }, " En nombre propio o en representación de una persona natural o jurídica, todo lo cual se encuentra legalmente acreditado, me permito declarar que: "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, " El negocio y los recursos que utiliza para la ejecución y desarrollo normal de las actividades, no provienen de ninguna actividad ilícita de las contempladas en el Código Penal Colombiano o en cualquier norma que lo modifique o adicione. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El negocio cumple con las normas y regulaciones colombianas relacionadas con la prevención y control al lavado de activos y al financiamiento del terrorismos que le son aplicables. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El negocio cuenta con políticas, manuales y procedimientos de prevención y control al lavado de activos y a la financiación del terrorismo, quedan cabal al cumplimiento a las regulaciones vigentes que le son aplicables. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Ni los accionistas o asociados se encuentran vinculados en las listas restrictivas (Listas de las Naciones Unidas o de la OFAC), o han sido sancionados, ni existe en curso investigaciones o procesos penales por delitos relacionados con LA/FT. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Me comprometo a comunicar a Aportes en Línea sobre cualquier evento relacionado en los numerales anteriores, en el momento en que tenga conocimiento de que alguno de estos ocurra. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Me comprometo a entregar a Aportes en Línea toda la información que le sea solicitada para dar cumplimiento a las disposiciones relacionadas con la Prevención del Lavado de Activos y Financiación del Terrorismo y declaro que la misma es veraz y verificable. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " En el evento en que no cumpla con las presentes declaraciones y eventuales obligaciones definidas en los contratos que lleguen a celebrarse con Aportes en Línea, Aportes en Línea podrá dar por terminado el contrato de manera inmediata, sin que por este hecho haya lugar al pago de sanción o indemnización alguna, bastará la comunicación por escrito, incluyendo el correo electrónico, que sobre esta decisión haya tomado Aportes en Línea. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " El Representante Legal autoriza a Aportes en Línea, y a quien en el futuro represente sus derechos, de manera irrevocable, para consultar y reportar a cualquier entidad que maneje o administre bases de datos que tengan fines de información, financieros, estadísticos, de control, supervisión, gerenciales y de consolidación de información, todos los datos económicos, incluyendo la información referente a su comportamiento comercial y crediticio. Como consecuencia de esta autorización Aportes en Línea podrá consultar e incluir sus datos financieros y comerciales en las bases de datos antes mencionadas, en las cuales se verá reflejado su actual y pasado comportamiento en relación con el cumplimiento o incumplimiento de sus obligaciones, información que permanecerá reportada por los términos previstos en la Ley o en su defecto en los reglamentos de dichas sociedades. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("li", null, " Autorizo a Aportes en Línea, y a quien en el futuro represente sus derechos, de manera expresa e irrevocable, para que Aportes en Línea o las empresas del Grupo Aval, Acciones y Valores S.A., tengan acceso a toda la información y documentación que tenga relación con la presente declaración. "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Aceptar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": "top",
    "label-width": "auto",
    class: "greenItem"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24,
            style: {"padding-top":"15px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_el_tooltip, {
                  placement: "bottom",
                  "open-delay": "0",
                  effect: "customized",
                  class: "tooltip-adjuntos"
                }, {
                  content: _withCtx(() => [
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'info-circle'],
                      color: "#00805d",
                      style: {"font-size":"13px","margin-top":"4px"}
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "Documento de identidad de personas naturales y representantes principales.*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "RUT y/o original certificado de existencia y representación legal no mayor a 30 días (obligatorio para quienes tienen registro de su actividad económica ante la Cámara de Comercio).*" })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.DocumentosIdentidad.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.Certificados.ExtensionesArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarDocumentoIdentidad,
                "on-change": _ctx.CargarDocumentoIdentidad,
                "file-list": _ctx.documentosIdentidad,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.DocumentosIdentidad.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objetoArchivos.DocumentosIdentidad.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                "on-remove": _ctx.EliminarCertificado,
                "on-change": _ctx.CargarCertificado,
                "file-list": _ctx.certificados,
                "auto-upload": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    size: "medium"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "hidden",
                        modelValue: _ctx.objetoArchivos.Certificados.ExtensionesArchivos,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objetoArchivos.Certificados.ExtensionesArchivos) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change", "file-list"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.DeclaracionJuradaVeracidad.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.objetoArchivos.DeclaracionJuradaVeracidad,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objetoArchivos.DeclaracionJuradaVeracidad) = $event)),
                class: "declaracion-veracidad-checkbox"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 24,
            md: 24,
            lg: 24,
            xl: 24
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.NombresArchivos.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validacionArchivos.TamañoArchivo.$errors, (error) => {
                return (_openBlock(), _createBlock(_component_el_form_item, {
                  key: error.$uid
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error.$message), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.mostrarMensajeLAFT,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mostrarMensajeLAFT) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { class: "ParrafosInfoAdicionalLAFT" }, {
                    default: _withCtx(() => [
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_22, [
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mostrarMensajeLAFT = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}